<template>
    <div class="wrapper">
        <h2 class="page_title">{{ $t("page.remonline.title") }}</h2>
        <div class="container_block">
            <UnorderedListRecurring list="page.remonline.activationList" />
            <br class="my-3" />
            <BaseCardInstruction
                class="card_instruction"
                :text="$t('page.remonline.more_information')"
                :buttonText="$t('common.instruction')"
                @clickButton="onClickInstructions"
            />
        </div>
    </div>
</template>

<script setup>
import UnorderedListRecurring from "@/components/Recurring/UnorderedListRecurring.vue";
import BaseCardInstruction from "@/components/Instruction/BaseCardInstruction.vue";

const linkRemonline =
    "https://help.remonline.app/uk/articles/9297117-%D1%8F%D0%BA-%D0%BF%D1%96%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B8%D1%82%D0%B8-telegram-%D0%B4%D0%BE-%D1%87%D0%B0%D1%82%D1%96%D0%B2-remonline";

const onClickInstructions = () => {
    window.open(linkRemonline);
};
</script>

<style lang="scss" scoped>
@use "@/styles/pages/instruction.scss";

.card_instruction {
    width: fit-content;
}
</style>
